import { LocalizedString } from '../common';

export interface GpsStepItem {
  time: number;
  rotation?: number;
  coords: { lat: number; lng: number };
}

export interface GPSPoint {
  lat: number;
  lng: number;
}

export interface MapPoint {
  x: number;
  y: number;
}

export interface ReferencePoint {
  gps: GPSPoint;
  map: MapPoint;
}

export interface GpsCoordinate {
  lat: number;
  lng: number;
}

export interface GeolocationPositionBasic {
  coords: {
    latitude: number;
    longitude: number;
    accuracy?: number;
    altitude?: number;
    altitudeAccuracy?: number;
    heading?: number;
    speed?: number;
  };
}

export enum ShowOnFloorplanEnum {
  Default = 0,
  None = 1,
  OnlyCategoryIcon = 2,
  OnlyImage = 5,
  OnlyName = 6,
  CategoryIconAndName = 3,
  CategoryIconAndImage = 4,
  ImageAndName = 7,
  OnlyCode = 12,
  CategoryIconAndCode = 13,
  CodeAndName = 14,
}

export interface ZoomLevelLimits {
  defaultZoom: number;
  minZoom: number;
  maxZoom: number;
}

export enum ShowOnFloorplanWhenActiveDetailEnumDEP {
  Default = 0,
  None = 1,
  OnlyCategoryIcon = 2,
  OnlyImage = 5,
  OnlyName = 6,
  CategoryIconAndName = 3,
  CategoryIconAndImage = 4,
  ImageAndName = 7,
  OnlyCode = 12,
  CategoryIconAndCode = 13,
}

export enum ShowOnFloorplanWhenActiveRouteEnum {
  Default = 0,
  None = 8,
  Icon = 9,
  Image = 10,
  Name = 11,
}

export interface GeometryPointData {
  type: string;
  coordinates: number[];
}

export interface GeometryLineStringData {
  type: string;
  coordinates: number[][];
}

export interface GeometryPolygonData {
  type: string;
  coordinates: number[][][];
}

export interface GeometryDataInfo {
  type: string;
  coordinates: any;
}

export interface NavigationGeodataObject {
  areaId: number;
  geometry: GeometryPointData | GeometryLineStringData | GeometryPolygonData | GeometryDataInfo;
  qrCodeId: string;
  qrCategoryColor: string;
  objectsData: ControllableObjectMapItem[];
  showOnFloorplan: ShowOnFloorplanEnum;
  showOnFloorplanAboveIcon: ShowOnFloorplanWhenActiveRouteEnum;
  showOnFloorplanDetail: ShowOnFloorplanEnum;
  zoomPoi: boolean;
  poiSize: number;
  redirectToResource: boolean;
  resourceId: number;
}

export interface Message {
  type: ControllableObjectMessageType;
  iconUrl: string;
  text: LocalizedString;
  id: string;
}

export interface Item {
  id: string;
  type: string;
  state?: string;
  indication?: string;
  iconUrl?: string;
  label?: LocalizedString;
  value?: LocalizedString;
  valueType?: string;
  unit?: LocalizedString;
  repeatButtonInterval?: number;
}

export interface Group {
  id: string;
  label: LocalizedString;
  message: Message;
  item: Item[];
}

export interface MonitorItem {
  id: string;
  iconUrl?: string;
  label?: LocalizedString;
  value?: LocalizedString | string | number;
  unit?: LocalizedString;
  color?: string;
  minimum?: number;
  maximum?: number;
  step?: number;
}

export enum OpenDetailFromEnum {
  None = 'None',
  StartSelection = 'StartSelection',
  TargetSelection = 'TargetSelection',
  MapOrNavbarSelection = 'MapOrNavbarSelection',
}

export enum ControllableObjectMessageType {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  Nothing = 'nothing',
}

export enum ControllableObjectType {
  Control = 'control-1',
  Monitor = 'monitor-1',
  Indicator = 'indicator-1',
  Slider = 'slider-1',
  TimeInput = 'time-input-1',
  LongNumberInput = 'long-number-input-1',
  DoubleNumberInput = 'double-number-input-1',
}

export interface ControlableObjectBasicInfo {
  id: string;
  name: string;
  type: ControllableObjectType;
  rank: number;
  qrCodeId: string;
}

export interface ControllableObjectMapItem {
  name: string;
  objectId: string;
  rank: number;
  data: ControllableObjectDetail;
  showInMap: ShowInMapOrDetailModeEnum[];
  projectObjectCollapseId: ProjectObjectCollapsedEnum;
  projectObjectSizeId: ProjectObjectSizeEnum;
}

export enum ProjectObjectSizeEnum {
  Small = 1,
  Medium = 2,
  Large = 3,
  CollapsedLocked = 4,
}

export enum ProjectObjectCollapsedEnum {
  ExpandedDefault = 1,
  ExpandedLocked = 2,
  CollapsedDefault = 3,
  CollapsedLocked = 4,
}

export enum ShowInMapOrDetailModeEnum {
  Label = 1,
  Control = 2,
  ObjectLabel = 3,
  Icon = 4,
  Value = 5,
  Unit = 6,
  Color = 7,
  Arrows = 8,
  Limits = 9,
}

export enum UnitStatusEnum {
  NotAvailable = 1,
  DataReady = 2,
}

export interface ControllableObjectShowInDetail {
  showInDetail: ShowInMapOrDetailModeEnum;
  qrCodeId: string;
}

export interface ControllableObjectDetailDataCrate {
  data: ControllableObjectDetail;
  showInDetail: ControllableObjectShowInDetail[];
  unitStatus: UnitStatusEnum;
}

export interface ControllableObjectDetail {
  objectId: string;
  name: string;
  type?: ControllableObjectType;
  version?: number;
  label?: LocalizedString;
  iconUrl?: string;

  //TODO:Jakub rozdelit objektove
  //item pouze pro type Control
  message?: Message;
  //TODO:Jakub rozdelit objektove
  //item pouze pro type Control
  group?: Group[];
  //TODO:Jakub rozdelit objektove
  //item pouze pro type Monitor
  item?: MonitorItem[];
  //TODO:Jakub rozdelit objektove
  //item pouze pro type Indicator a Monitor
  color?: string;
  //item pouze pro type Indicator
  value?: LocalizedString;
}
